// src/components/Profile/CancelOrderModal.jsx
import React from 'react';

export default function CancelOrderModal({
  order,
  isOpen,
  cancellationReason,
  setCancellationReason,
  isCancelling,
  cancelError,
  setCancelError,
  onConfirm,
  onClose
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !isCancelling && onClose()}>
      <div className="modal-content cancel-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Cancel Order</h3>
          <button className="close-btn" onClick={onClose} disabled={isCancelling}>
            <i className="ph ph-x"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="cancel-warning">
            <i className="ph ph-warning-circle"></i>
            <p>
              Are you sure you want to cancel order <strong>#{order.order_number}</strong>?
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="cancellation-reason">
              Cancellation Reason <span className="required">*</span>
            </label>
            <textarea
              id="cancellation-reason"
              className="form-control"
              rows="4"
              placeholder="Please provide a reason for cancelling this order..."
              value={cancellationReason}
              onChange={(e) => {
                setCancellationReason(e.target.value);
                setCancelError('');
              }}
              disabled={isCancelling}
              maxLength={500}
            />
            <small className="char-count">{cancellationReason.length}/500 characters</small>
          </div>

          {cancelError && (
            <div className="alert alert-danger">
              <i className="ph ph-warning"></i>
              {cancelError}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={isCancelling}>
            Keep Order
          </button>
          <button
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={isCancelling || !cancellationReason.trim()}
          >
            {isCancelling ? (
              <>
                <i className="ph ph-spinner spinner-icon"></i>
                Cancelling...
              </>
            ) : (
              <>
                <i className="ph ph-x-circle"></i>
                Yes, Cancel Order
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}